<template>
  <div class="qs_box">
    <div class="qs_title" v-html="data.Title" @click="
        $router.push(`${$subsitePrefix}/ss/support/question/detail/${data.Id}`)
      "></div>
    <div class="qs_author">
      <span>提问人：</span>
      <span class="name" v-html="data.RaiseByName"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "question-card",
  props: {
    data: {
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped>
.qs_box {
  padding: 16px 0;
  border-bottom: 1px solid #eee;
  .qs_title {
    font-size: 18px;
    cursor: pointer;
    color: #333333;
    &:hover {
      color: $primary-color;
    }
  }
  .qs_author {
    margin-top: 4px;
    color: #999999;
    font-size: 14px;
    .name {
      margin-left: 8px;
    }
  }
}
</style>
